import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'hypenation-shared-shopping-cart',
  standalone: true,
  imports: [CommonModule,NzBadgeModule, NzIconModule],
  templateUrl: './shopping-cart.component.html',
  styleUrl: './shopping-cart.component.css',
})
export class ShoppingCartComponent {
  @Input() numberOfItems = 0;
}
